import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Link } from 'react-router';
import {
  loadFestivalProgramEventsByCategory,
  loadFestivalEventCategories,
  loadFestivalProgramLP,
  loadFestivalEvents,
  loadOrgsByType
} from '../actions';
import DocumentMeta from 'react-document-meta';
import ProgramCategory from '../components/festival/program/ProgramCategory';
import { isEmpty } from 'lodash/lang';
import { filter } from 'lodash/collection';


class FestivalProgram extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    sideBarNavOpen: false,
    page: 'default',
    isTapped: false
  }

  componentWillMount() {
    this.props.loadFestivalEventCategories();
    this.props.loadFestivalProgramLP();
    this.props.loadOrgsByType({
      is_festival_exhibitor: true
    });

    if (isEmpty(this.props.routeParams)) {
      this.setState({page: 'default'});
    } else {
      this.setState({page: this.props.routeParams.id});
      this.props.loadFestivalProgramEventsByCategory(
        {
          category_id: this.props.routeParams.id
        }
      )
    }
  }

  componentWillReceiveProps(nextProps) {

  }


  componentDidMount() {
    window.scrollTo(0, 0);
  }

  opensideBarNav = (e) => {
    this.setState({ sideBarNavOpen: !this.state.sideBarNavOpen })
  }

  handleTap = (e) => {
    e.preventDefault()
    this.setState({isTapped: !this.state.isTapped})
  }

  handleSidebarLinkClick = (id, slug, is_exhibitor_list) => {
    // id is the event category id
    this.setState({page: id, isTapped: false})

    this.props.loadFestivalProgramEventsByCategory(
      {
        category_id: id
      }
    )

    // Update url in browser address bar
    this.props.push(`/girls-festival/program/${id}/${slug}`)
  }

  render() {
    if (!this.props.girlsFestivalEventCategories.isLoaded) {
      return  <span />;
    }

    if (!this.props.girlsFestivalProgramLP.isLoaded) {
      return  <span />;
    }

    let programCategories = this.props.girlsFestivalEventCategories;
    let eventsByCateory = this.props.girlsFestivalEventsByCategory;
    let pageTitleObj;
    let sideBarNav;
    let sideBarNavLinks;
    let programCard;
    let sideBarLinkClass;
    let caretIcon;
    let tapStatus;

    let currentProgramCard;
    let bannerImgTagDesktop;
    let bannerImgTagMobile;

    let bannerUrlDesktop;
    let bannerUrlMobile;

    // Get current event category obj
    let page = this.state.page;
    currentProgramCard = filter(programCategories, function(obj) {
      return obj.id == page
    })



    // Get bannerUrl for current page
    if (this.state.page == 'default') {
      bannerImgTagDesktop = <img className="desktop" src="/images/festival/program/program_banner_lp.jpg" />

      bannerImgTagMobile = <img className="mobile" src="/images/festival/program/program_banner_lp_mobile.jpg" />
    } else {
      bannerUrlDesktop = currentProgramCard[0].event_banner_desktop;
      bannerImgTagDesktop = <img className="desktop"
      src={bannerUrlDesktop} />

      bannerUrlMobile = currentProgramCard[0].event_banner_mobile;
      bannerImgTagMobile = <img className="mobile"
      src={bannerUrlMobile} />
    }


    // Used for mobile menu
    if (this.state.isTapped) {
      tapStatus = 'is-tapped'
      caretIcon = <i className="fa fa-chevron-up"></i>
    } else {
      tapStatus = '';
      caretIcon = <i className="fa fa-chevron-down"></i>
    }

    // Build sideBarNav list
    sideBarNavLinks = programCategories.map((item, index) => {
      return <li className={item.slug} onClick={this.handleSidebarLinkClick.bind(this, item.id, item.slug, item.is_exhibitor_list)} key={item.id}>
        {item.event_title}
      </li>
    });



    sideBarNavLinks = <ul className={tapStatus}>
      {sideBarNavLinks}
    </ul>

    sideBarNav = sideBarNavLinks;


    if(!this.props.browser.greaterThan.desktop && !this.state.isTapped) { // Mobile menu closed
      sideBarNav = '';

    } else if (!this.props.browser.greaterThan.desktop && this.state.isTapped) { // Mobile menu open
      sideBarNav = sideBarNavLinks;
    }


    return(
      <div>

        <div className="festivalHome-bannerWrapper">
          <Link to="/girls-festival/tickets">{bannerImgTagDesktop}</Link>

          <Link to="/girls-festival/tickets">{bannerImgTagMobile}</Link>
        </div>

        <div id="mobile-subnav-wrapper">
          <div id="mobile-subnav" className="subnavigation">

            <div onClick={this.handleTap} className="sub-menu-icon">
              <a href="#">Program {caretIcon}</a>
            </div>
            {sideBarNav}

          </div>
        </div>



        <div className="content-wrapper">

          <div className="festivalProgram2ColWrapper">
            <div className="festivalProgramSidebar-wrapper festivalSidebar-wrapper">
              <div style={{paddingLeft: '20px'}} className="festivalSidebar-header">
                PROGRAM
              </div>
              {sideBarNav}
            </div>

            <div className="festivalProgram-bodyWrapper festivalMainBody-wrapper">


              <ProgramCategory
                programCategories={this.props.girlsFestivalEventCategories}
                programLP={this.props.girlsFestivalProgramLP}
                page={this.state.page}
                girlsFestivalProgramEventsByCategory={this.props.girlsFestivalProgramEventsByCategory}
                orgsByType={this.props.orgsByType}
                loadOrgsByType = {this.props.loadOrgsByType}
              />
              <div style={{marginBottom: '4.0rem'}}>&nbsp;</div>

            </div>
          </div>




        </div>



      </div>
    );
  }
};

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  {
    loadFestivalProgramEventsByCategory,
    loadFestivalEventCategories,
    loadFestivalProgramLP,
    loadFestivalEvents,
    loadOrgsByType,
    push
  }

)(FestivalProgram);



// WEBPACK FOOTER //
// ./src/containers/FestivalProgram.jsx